// extracted by mini-css-extract-plugin
export default {"workBar":"workbar_workBar__fGhbw"};